<script>
  import { useNavigate } from 'svelte-navigator';

  export let row = {};

  const navigate = useNavigate();
  const cache = Math.random() * 10000;
</script>

<div class="preview" on:click={() => navigate(row.rulename)} role="button" tabindex="0">
  <img
    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    style="background: url({row.thumbnail}?{cache}) no-repeat center center;"
    loading="lazy"
    alt={row.thumbnail}
  />
</div>

<style lang="scss">
  .preview {
    cursor: pointer;
    position: relative;
    user-select: none;

    img {
      background-size: contain !important;
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius-base);
      height: auto;
      image-rendering: pixelated;
      width: 75px;
    }
  }
</style>
